import { keyframes } from 'styled-components';

export const aboveMobile = '768px';
export const aboveTablet = '980px';
export const desktop = '1200px';
export const largeDesktop = '1600px';

// Create the keyframes
export const skeletonKeyframes = keyframes`
  from {
    background-color: rgba(255,255,255,0.1)
  }

  to {
    background-color: rgba(255,255,255,0.4)
  }
`;
